import React from 'react';

export const PlayListItem = ({track, onTrackClick, isCurrentTrack, audioPlayerIsLoading}) => {

    const handleTrackClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onTrackClick(track);
    }
    return (
        <div className={'playlist-item' + (isCurrentTrack ? ' active' : '') + (audioPlayerIsLoading ? ' track-loading' : '') } onClick={handleTrackClick}>
            <div className="artist">{track?.artist}</div>
            <div className="playlist-item-lower">
                <div className="title">{track?.title}</div><div className="duration">{track?.lenght}</div>
            </div>
        </div>
    );
}